export default (count) => ({
  count: 0,
  page: 0,

  next() {
    this.page = this.page === (this.count - 1) ? 0 : this.page + 1;
  },

  prev() {
    this.page = this.page === 0 ? (this.count - 1) : this.page - 1;
  },

  init() {
    this.count = count;
  },
});
